import askomaFrontendService from "./api/askomaFrontend.service";

const askomaService = {
  ...askomaFrontendService,
};

export default askomaService;
